import { render, staticRenderFns } from "./templatelist.vue?vue&type=template&id=be75fe1a&scoped=true&"
import script from "./templatelist.vue?vue&type=script&lang=js&"
export * from "./templatelist.vue?vue&type=script&lang=js&"
import style0 from "./templatelist.vue?vue&type=style&index=0&id=be75fe1a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be75fe1a",
  null
  
)

export default component.exports